<div class="character-counter">
	<div [className]="currentLength < maxLength ? 'no-warn' : 'warn'">{{ currentLength }} / {{ maxLength }}</div>
</div>
